import PropTypes from 'prop-types'
import {List, Map} from 'immutable'

import {Button, Cancel} from '../../blocks/Buttons'
import ButtonGroup from '../../../../../shared_components/core/buttons/ButtonGroup'
import SuggestedDeputies from '../../corp_max_deputies/SuggestedDeputies'
import {showsSuggestedDeputies, suggestedDeputiesEverplanId} from '../../../../../lib/deputyPermissionTools'

const NoPermissionsLinkAndButtons = props => (
  <div className='no-permissions-link-and-buttons'>
    {
      showsSuggestedDeputies(props) &&
      <SuggestedDeputies
        deputies={props.deputies}
        everplanId={suggestedDeputiesEverplanId(props)}
        firstGroupId={props.firstGroupId}
        itemResponses={props.itemResponses}
        vaultExtension={props.vaultExtension}
        onAddDeputy={props.addNewDeputyLink}
        onShareWithDeputy={props.setDeputyToShareWith}
        context={props.context}
      />
    }
    <a className='add-deputy-link' onClick={() => props.addNewDeputyLink()}>
      Add a new Deputy
    </a>
    <ButtonGroup>
      <Cancel onClick={props.toggleModal}>Cancel</Cancel>
      <Button disabled>Share</Button>
    </ButtonGroup>
  </div>
)

NoPermissionsLinkAndButtons.propTypes = {
  addNewDeputyLink: PropTypes.func,
  context: PropTypes.string,
  deputies: PropTypes.instanceOf(List),
  firstGroupId: PropTypes.string,
  itemResponses: PropTypes.instanceOf(List),
  vaultExtension: PropTypes.instanceOf(Map),
  toggleModal: PropTypes.func,
  setDeputyToShareWith: PropTypes.func
}

export default NoPermissionsLinkAndButtons
